import { loadFont } from '@remotion/fonts';
import { staticFile } from 'remotion';
import { buildLocalFontInfo } from './load-font-info';
import { getFontFamilyFallbacks } from './font-family-css-stack';

// 드롭다운 프리뷰용 폰트 이름은 본문 렌더링과 충돌하지 않도록 분리
export const makeFontPreviewName = (fontFamily: string) => {
  // 동일한 이름으로 로드된 폰트를 덮어쓰지 않도록 프리뷰 전용 이름을 생성합니다
  return `${fontFamily}Preview`;
};

const resolveFontUrl = (sourcePath: string) => {
  if (/^https?:\/\//.test(sourcePath)) {
    return sourcePath;
  }

  const normalized = sourcePath.startsWith('/')
    ? sourcePath.slice(1)
    : sourcePath;

  return staticFile(normalized);
};

const loadFontFace = async ({
  fontFamily,
  familyAlias,
}: {
  fontFamily: string;
  familyAlias: string;
}) => {
  const info = buildLocalFontInfo(fontFamily);
  // 프리뷰는 폰트의 기본 weight 파일을 로드
  const fontPath = info.getPathByWeight(info.defaultWeight);

  await loadFont({
    family: familyAlias,
    url: resolveFontUrl(fontPath),
    weight: info.defaultWeight,
    style: 'normal',
  });
};

// 프리뷰에서도 로컬 woff 자산을 직접 로드
export const loadFontPreview = async (fontFamily: string): Promise<void> => {
  const info = buildLocalFontInfo(fontFamily);

  await Promise.all([
    loadFontFace({
      fontFamily: info.family,
      familyAlias: makeFontPreviewName(info.family),
    }),
    ...getFontFamilyFallbacks(info.family).map((fallbackFamily) =>
      loadFontFace({
        fontFamily: fallbackFamily,
        familyAlias: fallbackFamily,
      }),
    ),
  ]);
};
